import { Button, Checkbox, Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { Delete_Category_Api, IsInCategory_Category_Api } from '../../API/CategoryApi';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';

// =================================================================
export const ACategoryComponent = ({ setLoading, showMessage, category, isShowAddSubCategory
    , isShowEdit, isShowDelete, onRowDeleted, editClick, addSubCategoryClick, isShowCheckBox
    , onCheckChange, isLoadObjectInstanceCategories, isLoadCategoryFromParam, selectedCategory
    , objectInstanceId, onClickItems 
    ,isChecked = false, selectedCategories = [], 
     }) => {

        
    // ======================================================================
    const [isInCategory, setIsInCategory] = useState(false);
    // ======================================================================
    useEffect(() => {
        if (isLoadObjectInstanceCategories == true)
            loadIsInCategory();
        else if (isLoadCategoryFromParam == true && category.id == selectedCategory)
            setIsInCategory(true)
        else if (isLoadCategoryFromParam == true && category.id != selectedCategory)
            setIsInCategory(false);

    }, []);

    useEffect(() => {
        if (isLoadCategoryFromParam == true && category.id == selectedCategory)
            setIsInCategory(true)
        else if (isLoadCategoryFromParam == true && category.id != selectedCategory)
            setIsInCategory(false)

    }, [category, selectedCategory]);
    // =================================================================
    const loadIsInCategory = async () => {
        setLoading(true);
        try {
            const data = await IsInCategory_Category_Api({ "categoryId": category.id, "objectInstanceId": objectInstanceId });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setIsInCategory(data.messageData.data);
            }
            else {
                showMessage(data.message, "error")
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const deleteRow = async (id) => {
        try {
            setLoading(true);
            let data = await Delete_Category_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                onRowDeleted();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const checkChanged = async (checked) => {
        onCheckChange(category.id, checked);
        setIsInCategory(checked);
    }

    const handleTextClick = () => {
        if (isShowCheckBox) {
            const newCheckedState = !isChecked;
            const newSelectedCategories = newCheckedState 
                ? [...selectedCategories, category.id] // اضافه کردن
                : selectedCategories.filter(id => id !== category.id); // حذف کردن
            
            // به والد اطلاع بده
            if (onCheckChange) {
                onCheckChange(category.id, newCheckedState);
            }
            
            // اگر onClickItems داریم، لیست جدید را بفرست
            if (onClickItems) {
                // مشکل: ما categoryTitles را نداریم!
                // پس باید ساختار onClickItems را تغییر دهیم
            }
        } else if (onClickItems) {
            onClickItems(category.id, category.title);
        }
    };
    // =================================================================
    return (
        <div>
            <text className={onClickItems ? 'clickable' : ''}
                // onClick={() => { if (onClickItems) onClickItems(category.id,[], category.title) }} 
                onClick={handleTextClick}
                >
                {category.title}
            </text>
            {isShowCheckBox ?
                <Checkbox style={{ marginRight: '5px' }} onChange={(e) => { checkChanged(e.target.checked) }} checked={isInCategory}></Checkbox> : <></>
            }
            {isShowCheckBox && (
            <input
                type="checkbox"
                checked={isChecked} // استفاده از prop
                onChange={(e) => onCheckChange(category.id, e.target.checked)}
                style={{ marginLeft: '10px' }}
            />
        )}
            {isShowAddSubCategory ?
                <Button
                    className='btn-primary'
                    style={{ border: '0px', marginRight: '5px', padding: '10px' }}
                    onClick={() => {
                        addSubCategoryClick(category.id, category.title)
                    }}
                ><PlusOutlined /></Button> : <></>
            }

            {isShowEdit ? (
                <Button
                    className="btn-success"
                    style={{ border: '0px', marginRight: '5px', padding: '10px' }}
                    onClick={() => {
                        editClick(category.id);
                    }}
                ><EditOutlined />
                </Button>
            ) : (<></>)
            }
            {isShowDelete ? (
                <Button
                    className='btn-danger'
                    style={{ border: '0px', marginRight: '5px', padding: '10px' }}
                    onClick={() => {
                        Modal.confirm({
                            title: 'آیا از حذف ' + category.title + ' اطمینان دارید؟',
                            onOk: () => { deleteRow(category.id) },
                            footer: (_, { OkBtn, CancelBtn }) => (
                                <>
                                    <CancelBtn />
                                    <OkBtn />
                                </>
                            ),
                        });
                    }}
                ><DeleteOutlined /></Button>
            ) : (<></>)}
        </div>
    )
}
